import { styled } from "../../theme";

export const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: space-evenly;
`;
export const ResourceListTitleContainer = styled.div`
  min-height: 10%;
  align-self: flex-start;
  padding-top: 1em;
  .title_level_2 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.color.primary};
    text-align: left;
    padding-left: 2em;
    padding-bottom: 0.2em;
    border-bottom: 0.2em ${({ theme }) => theme.color.primary} solid;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
      padding-left: 1em;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 3em;
    position: relative;
    font-size: 0.9em;
    padding-top: 5em;
    padding-bottom: 2em;
    max-width: 90%;
    padding: 0.5em;
  }
`;

export const ResourceListContainer = styled.ul`
  display: flex;
  width: 100%;
  padding: 2em;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  list-style: none;
  justify-content: space-between;
  box-sizing: border-box;
  margin-top: 0;
  margin-bottom: 0;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    padding: 0.5em;
  }
`;

export const ItemContainer = styled.li`
  width: 50%;
  box-sizing: border-box;
  min-height: 6em;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 90%;
    padding-bottom: 1.5em;
    min-height: 4em;
  }
`;
export const SideBarStyle = styled.div`
  width: 100%;
  max-height: 90%;
  .simplebar-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .simplebar-track {
    right: 1em;
  }
  .simplebar-scrollbar.simplebar-visible:before {
    /* When hovered, remove all transitions from drag handle */
    opacity: 1;
    transition: opacity 0s linear;
  }
  .simplebar-scroll-content {
  }
  .simplebar-scrollbar::before {
    background-color: ${({ theme }) => theme.color.scrollbar};
  }
  .track {
  }
`;
